import React from "react";

const MIN_WIDTH = 768;

const DeviceGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const isMobile = window.innerWidth < MIN_WIDTH;

    if (isMobile) {
        return (
            <div style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                padding: 24,
                backgroundColor: "#f0f2f5"
            }}>
                <div>
                    <h2>Unsupported Device</h2>
                    <p>This app is designed for tablets and desktop devices only.</p>
                    <p>Please access it using a device with a larger screen.</p>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default DeviceGuard;